import { service } from "../../../services";
import { router } from "../../../router";
import db from "@/firebase";

const state = {
  loading: false,
  error: null,
  users: []
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },

  setError(state, error) {
    state.error = error;
    state.loading = false;
  },

  setUsers(state, users) {
    state.users = users;
    state.loading = false;
  }
};

const actions = {
  async fetchUsers({ commit }, date) {
    try {
      commit("setLoading", true);
      await db
        .collection("availability")
        .doc(date)
        .collection("users")
        .get();
      await function(querySnapshot) {
        let newUsers = [];
        querySnapshot.forEach(doc => {
          newUsers.push({
            id: doc.id,
            ...doc.data()
          });
        });
        commit("setUsers", newUsers);
      };
    } catch (err) {
      commit("setError", err);
    }
  },

  async updateAvailability({ commit }, payload) {
    try {
      await commit("setLoading", true);
      await db
        .collection("availability")
        .doc(payload.week)
        .collection("days")
        .doc(payload.date)
        .collection("users")
        .doc(payload.id)
        .set({
          name: payload.name,
          am: payload.am,
          pm: payload.pm
        });

      commit("setLoading", false);
    } catch (err) {
      commit("setError", err);
    }
  }
};

export const availability = {
  namespaced: true,
  state,
  actions,
  mutations
};
